import { TAccount } from '@helpers/Accounts/accounts.types';

import { RblTopUpForm } from './rblTopUpForm/rblTopUpForm';
import { TopUpChoiceForm } from './TopUpChoiceForm/TopUpChoiceForm';
import { useGetTopupRequestData } from './useGetTopupRequestData';

export const TopupRequestDE = ({
    accountId
}: {
    accountId: NonNullable<TAccount['account_id']>;
}) => {
    const { isRBL } = useGetTopupRequestData(accountId);

    if (isRBL) {
        return (
            <div
                data-testid="topup-request-de"
                className="bg-structure-100 px-[15%] py-xl max-sm:px-[5%]"
            >
                <RblTopUpForm accountId={accountId} />
            </div>
        );
    }

    return (
        <div
            data-testid="topup-request-de"
            className="min-h-screen-offset bg-secondary-95 px-m pb-2xl"
        >
            <div className="mx-auto max-w-[960px] pt-l">
                <TopUpChoiceForm accountId={accountId} />
            </div>
        </div>
    );
};
